import React from 'react';
import PixKeySettings from '../features/settings/pix/PixKeySettings';

const PixKeySettingsPage: React.FC = () => <PixKeySettings />;

export default PixKeySettingsPage;
